import { useCallback } from 'react';

import { useAnalytics } from '@bonusly/who-am-i';

import { Bonus } from '../../../../types/bonus';
import { useContextualizedBonusDetails } from '../hooks/use-contextualized-bonus-details';

export enum BonusFeedTrackedAction {
	AvatarClick = 'Monarch Bonus Feed Avatar Click Action',
	BonusDelete = 'Monarch Bonus Feed Bonus Delete Action',
	BonusEdit = 'Monarch Bonus Feed Bonus Edit Action',
	BonusReport = 'Monarch Bonus Feed Bonus Report Action',
	BonusUrlCopy = 'Monarch Bonus Feed Bonus URL Copy Action',
	CommentDelete = 'Monarch Bonus Feed Comment Delete Action',
	CommentEdit = 'Monarch Bonus Feed Comment Edit Action',
	GiverClick = 'Monarch Bonus Feed Giver Click Action',
	InitiatorClick = 'Monarch Bonus Feed Initiator Click Action',
	ReactionCreate = 'Monarch Bonus Feed Reaction Create Action',
	ReactionDelete = 'Monarch Bonus Feed Reaction Delete Action',
	RecipientClick = 'Monarch Bonus Feed Recipient Click Action',
	TaggedUserClick = 'Monarch Bonus Feed Tag Click Action',
}

export const useTrackBonusFeedItemEvent = (bonus: Bonus | null, eventName: string) => {
	const { track } = useAnalytics();
	const { isUserReceiver, isCreatedByUser } = useContextualizedBonusDetails(bonus);

	return useCallback(() => {
		track(eventName, {
			isUserGiver: isCreatedByUser,
			isUserReceiver,
		});
	}, [track, eventName, isUserReceiver, isCreatedByUser]);
};
